const key = "add-isnotavailable-to-number";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[1-9]*$/);
};

const modify = (resp) => {
	const form = resp.data.Data;

	const numberFields = form.Fields.filter(f => f.Type.Code === "NUMBER");

	numberFields.forEach(f => f.IsNotAvailableEnabled = "Always");	
};

export const addIsNotAvailableToNumber = [key, applicable, modify];